import { TabLines } from '@toggle/design-system';
import styled from 'styled-components';

export const StyledTabLines = styled(TabLines)`
  & button[role='tab'] {
    white-space: nowrap;
  }
`;
